<template lang="html">
  <div id="status-bar">
    <aside class="bar-box">
      <div class="bar-inner" :style="{ width: (((id + 1) / totalQ)*100)+'%'}"></div>
    </aside>
    <span class="bar-status">{{ Math.round((((id + 1) / totalQ)*100))+'%' }}</span>
  </div>
</template>

<script>
export default {
  props: ['id'],
  computed: {
    totalQ() {
      // console.log(this.$store);
      let content = this.$store.state.flow.flow.length;
      return content;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/vars";
@import "../assets/scss/mixins";

#status-bar {
  width: 100%;
}

.bar-box {
  width: 100%;
  max-width: rem-calc(555);
  margin-top: gu(1.5);
  margin-left: auto;
  margin-bottom: gu(1.5);
  margin-right: auto;
  display: flex;
  background-color: $colFire;

  .bar-inner {
    height: 20px;
    background-color: $colOrange;
    transition: all .4s ease;
  }
}
</style>
